import missingPageImage from "../images/404.png";
const MissingPageImage = ({ imageProps }: any) => {
  return <img src={missingPageImage} alt="search" {...imageProps} />;
};

export default MissingPageImage;
